<template>
  <div class="row">
    <loader v-if="loading"></loader>
    <div v-else>
      <h1>Ações Extras do Passo "{{step.name}}"</h1>
      <hr>
      <router-link id="btn-add-field" :to="{name: 'StepActionDetail', params: {stepId: $route.params.stepId}}" type="button" class="btn btn-primary">
          <span class="glyphicon glyphicon-plus"></span> Adicionar Ação
      </router-link>
      <br><br>
      <loader v-if="updating"></loader>
      <div v-if="!actions.length" class="alert alert-info" id="msg-no-fields">
        O passo ainda não possui ações cadastradas.
      </div>
      <draggable v-model="actions" @end="checkMove" class="list-group" v-else>
          <div v-for="(f, index) in actions" class="list-group-item">
              <span>
                  <h4 class="list-group-item-heading">
                      <span v-if="f.type == 'form'" class="glyphicon glyphicon-text-size"></span>
                      <span v-if="f.type == 'link'" class="glyphicon glyphicon-link"></span>
                      {{f.name}}
                      <span class="pull-right">
                        <router-link v-if="f.type == 'form'" :to="{name: 'StepFieldList', params: {stepId: $route.params.stepId, actionId: f.objectId}}" type="button" class="btn btn-xs btn-success" title="Adicionar/Editar Campos do Formulário">
                          <span class="glyphicon glyphicon-plus"></span> Campos do Formulário
                        </router-link>
                        <router-link :to="{name: 'StepActionDetail', params: {stepId: $route.params.stepId, id: f.objectId}}" type="button" class="btn btn-xs btn-primary" title="Editar Ação">
                          <span class="glyphicon glyphicon-edit"></span> Editar
                        </router-link>
                        <button class="btn btn-xs btn-danger" @click="remove(f)" title="Remover Ação">
                          <span class="glyphicon glyphicon-remove"></span> Remover
                        </button>
                      </span>
                  </h4>
                  <p class="list-group-item-text">{{f.description }}</p>
              </span>
          </div>
      </draggable>
      <button type="button" class="btn btn-default" @click="cancel">Voltar</button>
    </div>
  </div>
</template>

<script>
import {
  Parse,
  miniToastr
} from '../Global'

import Loader from './util/Loader'
import draggable from 'vuedraggable'
import { handleParseError } from './util/ErrorHandling'

export default {
  components: {
    Loader,
    draggable
  },
  data () {
    return {
      loading: false,
      updating: false,
      actions: [],
      actionsParse: [],
      step: {}
    }
  },
  mounted () {
    this.getActionsData()
  },
  methods: {
    getActionsData () {
      let self = this
      self.loading = true
      let stepId = self.$route.params.stepId
      let query = new Parse.Query('Step')
      query.get(stepId).then(result => {
        self.step = result.toJSON()
        let queryActions = new Parse.Query('StepAction')
        queryActions.equalTo('step', result)
        return queryActions.find()
      }).then(results => {
        self.actionsParse = results
        self.actions = results.map(f => f.toJSON())
        self.loading = false
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    cancel () {
      this.$router.go(-1)
    },
    remove (action) {
      if (confirm('Deseja realmente esta ação?')) {
        let self = this
        self.loading = true
        let actionParse = self.actionsParse.find(f => f.id === action.objectId)
        actionParse.destroy({
          success () {
            miniToastr.success('Excluído com sucesso.')
            self.loading = false
            self.getActionsData()
          },
          error (obj) {
            self.loading = false
            miniToastr.error(obj.error)
          }
        })
      }
    },
    checkMove (evt) {
      if (evt.newIndex !== evt.oldIndex) {
        let self = this
        let updateList = []
        self.updating = true
        self.actions.forEach((action, index) => {
          let actionParse = self.actionsParse.find(f => f.id === action.objectId)
          actionParse.set('order', index)
          updateList.push(actionParse)
        })
        Parse.Object.saveAll(updateList).then(list => {
          self.actionsParse = list
          self.updating = false
        }).fail(error => {
          self.updating = false
          handleParseError(self, error)
        })
      }
    }
  }
}
</script>

<style>
.required {
  font-size: 10px;
  color: #c71916;
}
.private {
  font-size: 10px;
  color: #bbbb04;
}
</style>



// WEBPACK FOOTER //
// StepActionList.vue?0085eb64